export default __webpack_public_path__ + "static/media/green_tick_thick.77390432.svg";